import api from "@/api";
import { AxiosResponse } from "axios";
import NominalTicket from "@/types/NominalTicket";
import Coupon from "@/types/Coupon";
import Reservation from "@/types/Reservation";
import { groupBy } from "@/utils/array";
import Order from "@/types/Order";
import DataResponse from "@/types/DataResponse";

export default async function createOrder(
  reservation: Reservation,
  tickets: NominalTicket[],
  coupons: Coupon[],
  affiliateId: string | null,
): Promise<DataResponse<Order>> {
  // TODO: backend still expects tickets grouped by sector, we should prepare
  // to break this API soon and change both projects at the same time. On ticket-spa
  // just the request will continue to use this data structure, the rest of the code is already migrated.

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _formatted = tickets.map(({ section, sector, ...ticket }) => ({
    ...ticket,
  }));

  const _tickets = groupBy<NominalTicket, string>(_formatted, i => i.type.sector_id);

  const response: AxiosResponse<DataResponse<Order>> = await api.post(`/api/checkout/order`, {
    tickets: _tickets,
    reservation,
    coupon_codes: coupons.map(coupon => coupon.code),
    affiliateId,
  });

  return response.data;
}
